export const Legal_Information = 0;
export const TermsUse_Information = 1;